import React from "react";
import Meta from "./../components/Meta";
import AuthSection from "./../components/AuthSection";
import { useRouter } from "./../util/router";
import { useTranslation } from 'react-i18next';

function AuthPage(props) {
  const router = useRouter();
  const { t } = useTranslation();
  return (
    <>
      <Meta title={t("meta.auth.title")} />
      
      <AuthSection
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        type={router.query.type}
        //providers={["google"]}
        afterAuthPath={router.query.next || "/dashboard"}
      />
    </>
  );
}



export default AuthPage;
